
import { LoginForm } from "@/components/auth/LoginForm";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export default function LoginPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Check if user is already logged in
    const checkAuthStatus = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (session) {
        // If already authenticated, redirect to dashboard
        navigate('/dashboard');
      }
    };
    
    checkAuthStatus();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-primary">Minha Agência</h1>
        <p className="text-gray-600 mt-2">
          Plataforma completa para gestão de agências e redes sociais
        </p>
      </div>

      <LoginForm />
    </div>
  );
}
